import { useState, useEffect, useCallback } from 'react';
import { api } from './client';

export function useApi<T>(path: string) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const doFetch = useCallback(() => {
    setLoading(true);
    api<T>(path)
      .then((d) => { setData(d); setError(null); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [path]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api<T>(path)
      .then((d) => { if (!cancelled) { setData(d); setError(null); } })
      .catch((e) => { if (!cancelled) setError(e.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [path]);

  // グローバルrefetchイベントをリッスン
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (!detail || detail === path) doFetch();
    };
    window.addEventListener('api:refetch', handler);
    return () => window.removeEventListener('api:refetch', handler);
  }, [path, doFetch]);

  return { data, loading, error, refetch: doFetch };
}

/** 指定パスのuseApiを外部から再取得させる。パス省略で全useApiが再取得。 */
export function triggerRefetch(path?: string) {
  window.dispatchEvent(new CustomEvent('api:refetch', { detail: path ?? null }));
}
